import React from 'react';
import { StatisticCard } from '@/components/statisticCard';
import { FaClock, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

interface CreditControlStatsProps {
  pendingCount: number;
  approvedCount: number;
  rejectedCount: number;
}

export const CreditControlStats: React.FC<CreditControlStatsProps> = ({
  pendingCount,
  approvedCount,
  rejectedCount,
}) => {
  return (
    <div className="flex gap-4 overflow-x-auto mb-6">
      <StatisticCard
        title="Pending Approval"
        value={pendingCount}
        icon={<FaClock size={14} />}
        iconBgColor="#f59e0b"
        className="min-w-[177px]"
      />
      {/* <StatisticCard
        title="Approved Today"
        value={approvedCount}
        icon={<FaCheckCircle size={14} />}
        iconBgColor="#10b981"
        className="min-w-[177px]"
      />
      <StatisticCard
        title="Rejected Today"
        value={rejectedCount}
        icon={<FaTimesCircle size={14} />}
        iconBgColor="#ef4444"
        className="min-w-[177px]"
      /> */}
    </div>
  );
};

export default CreditControlStats;
